import React, { useState } from 'react';
import { submitContactForm } from '../services/api';
import './ContactSection.css';

export default function ContactSection() {
  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '',
    phone: '', evaluationType: '', message: '', agreeToSms: false
  });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const res = await submitContactForm(form);
      setStatus({ type: 'success', msg: res.message, ref: res.data?.referenceNumber });
      setForm({ firstName:'', lastName:'', email:'', phone:'', evaluationType:'', message:'', agreeToSms:false });
    } catch (err) {
      const errors = err.errors;
      const msg = Array.isArray(errors)
        ? (errors[0]?.message || errors[0])
        : 'An error occurred. Please try again.';
      setStatus({ type: 'error', msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-header">
         {/* <div className="eyebrow reveal">Get In Touch</div> */}
          <h2 className="section-h reveal d1" style={{ textAlign: 'center' }}>
            Get in <em>Touch</em>
          </h2>
          <p className="section-sub reveal d2" style={{ margin: '0 auto', textAlign: 'center' }}>
            Have questions? Our team is ready to help you get AccuGen set up for your enterprise.
          </p>
        </div>

        <div className="contact-grid">
          {/* Left dark info panel */}
          <div className="contact-info-panel reveal">
            <div className="cip-logo">
              <div className="cip-lm">AG</div>
              <div>
                <div className="cip-brand">AccuGen</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginTop: 2 }}>
                  Enterprise AI Evaluation
                </div>
              </div>
            </div>

            <p className="cip-desc">
              Ready to secure your AI applications? Reach out and we'll help you get AccuGen
              set up for your enterprise environment — often the same day.
            </p>

            <div className="cip-items">
              <div className="cip-item">
                <div className="cip-item-icon">
                  <img src="/icons/contact/contact_45_email.svg" alt="Email" />
                </div>
                <div>
                  <div className="cip-item-lbl">Email Us</div>
                  <div className="cip-item-val">accugen@proautomate.ai</div>
                </div>
              </div>
              {/* <div className="cip-item">
                <div className="cip-item-icon">🌐</div>
                <div>
                  <div className="cip-item-lbl">Platform URL</div>
                  <div className="cip-item-val">diq.eprodevops.com:3500</div>
                </div>
              </div> */}
              <div className="cip-item">
                <div className="cip-item-icon"> <img src="/icons/contact/organization.png" alt="Organization" /></div>
                <div>
                  <div className="cip-item-lbl">Organisation</div>
                  <div className="cip-item-val">
                    ProAutomate AI Integrations
                  </div>
                </div>
              </div>
            </div>

            <div className="cip-tags">
              {['OWASP Compliant','Enterprise Ready','Bias Detection','CI/CD Integration'].map(t => (
                <span key={t} className="cip-t">{t}</span>
              ))}
            </div>
          </div>

          {/* Right form card */}
          <div className="contact-form-card reveal d1">
            <div className="cfc-top">
              <h3>Schedule Your Evaluation</h3>
              <p>Request an Appointment</p>
            </div>
            <form className="cfc-body" onSubmit={handleSubmit}>
              <div className="cfc-row">
                <div className="form-grp">
                  <label className="form-lbl">First Name *</label>
                  <input className="form-inp" type="text" placeholder="John"
                    value={form.firstName} onChange={e => set('firstName', e.target.value)} required />
                </div>
                <div className="form-grp">
                  <label className="form-lbl">Last Name *</label>
                  <input className="form-inp" type="text" placeholder="Smith"
                    value={form.lastName} onChange={e => set('lastName', e.target.value)} required />
                </div>
              </div>
              <div className="form-grp">
                <label className="form-lbl">Work Email *</label>
                <input className="form-inp" type="email" placeholder="john@company.com"
                  value={form.email} onChange={e => set('email', e.target.value)} required />
              </div>
              <div className="form-grp">
                <label className="form-lbl">Phone Number</label>
                <input className="form-inp" type="tel" placeholder="+1 (555) 000-0000"
                  value={form.phone} onChange={e => set('phone', e.target.value)} />
              </div>
              <div className="form-grp">
                <label className="form-lbl">Evaluation Type</label>
                <select className="form-inp" style={{ appearance: 'none', cursor: 'pointer' }}
                  value={form.evaluationType} onChange={e => set('evaluationType', e.target.value)}>
                  <option value="">Select type...</option>
                  <option>OWASP LLM Security Audit</option>
                  <option>Bias &amp; Fairness Assessment</option>
                  <option>Response Quality Evaluation</option>
                  <option>Full Compliance Report</option>
                </select>
              </div>
              <div className="form-grp">
                <label className="form-lbl">Message *</label>
                <textarea className="form-ta" rows={4}
                  placeholder="Tell us about your AI system and evaluation needs..."
                  value={form.message} onChange={e => set('message', e.target.value)} required />
              </div>

              {status && (
                <div className={`contact-alert contact-alert-${status.type}`}>
                  {status.msg}
                  {status.ref && <div className="contact-ref">Reference: <strong>{status.ref}</strong></div>}
                </div>
              )}

              <button type="submit" className="form-btn" disabled={loading}>
                {loading ? 'Sending…' : 'Request Evaluation →'}
              </button>
              <p className="form-note">🔒 Your information is secure and never shared with third parties.</p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
